import { render, staticRenderFns } from "./SubTask.vue?vue&type=template&id=7781082a&"
import script from "./SubTask.vue?vue&type=script&lang=js&"
export * from "./SubTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7781082a')) {
      api.createRecord('7781082a', component.options)
    } else {
      api.reload('7781082a', component.options)
    }
    module.hot.accept("./SubTask.vue?vue&type=template&id=7781082a&", function () {
      api.rerender('7781082a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/SubTask.vue"
export default component.exports